<!-- 创建商品 -->
<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'khgl_khgl_khxx' }" style="position: absolute;top: 12px;left: 200px;"><el-button size="mini">回到商品列表</el-button></router-link>

		<div>
			<el-col :span="2">
				<el-menu default-active="1" class="el-menu-vertical-demo">
					<el-menu-item index="1" @click="list(1)"><span slot="title">客户信息</span></el-menu-item>
					<el-menu-item index="2" @click="list(2)"><span slot="title">销售线索</span></el-menu-item>
					<el-menu-item index="3" @click="list(3)"><span slot="title">拜访记录</span></el-menu-item>
					<el-menu-item index="4" @click="list(4)"><span slot="title">商机记录</span></el-menu-item>
					<el-menu-item index="5" @click="list(5)"><span slot="title">联系人</span></el-menu-item>
				</el-menu>
			</el-col>
			<el-col :span="22">
				<div style="width: 100%;" class="d-flex" v-if="classa == 1">
					<div style="width: 33%;">
						<el-form :model="form" label-width="80px">
							<el-form-item label="客户名称"><el-input v-model="form.name" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="座机号码"><el-input v-model="form.zjphone" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="详细地址"><el-input v-model="form.xxcity" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="关注人">
								<el-button type="success" size="mini">{{ form.gzr }}</el-button>
							</el-form-item>
							<el-form-item label="责任人">
								<el-button type="success" size="mini">{{ form.zrr }}</el-button>
							</el-form-item>
							<el-form-item label="释放人">
								<el-button type="success" size="mini">{{ form.sfr }}</el-button>
							</el-form-item>
							<el-form-item label="创建人">
								<el-button type="success" size="mini">{{ form.cjr }}</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div style="width: 33%;">
						<el-form :model="form" label-width="80px">
							<el-form-item label="联系人"><el-input v-model="form.lxr" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="电子邮件"><el-input v-model="form.email" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="备注"><el-input v-model="form.desc" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="共享商务">
								<el-button type="success" size="mini">{{ form.gxsw }}</el-button>
							</el-form-item>
							<el-form-item label="释放时间"><el-input v-model="form.sftime" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="创建时间"><el-input v-model="form.time" size="mini" style="width: 95%;"></el-input></el-form-item>
						</el-form>
					</div>
					<div style="width: 33%;">
						<el-form :model="form" label-width="80px">
							<el-form-item label="手机号码"><el-input v-model="form.phone" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="地区"><el-input v-model="form.city" size="mini" style="width: 95%;"></el-input></el-form-item>
							<el-form-item label="客户状态"><el-button type="success" size="mini" v-if="form.state == 1">潜在客户</el-button></el-form-item>
						</el-form>
					</div>
				</div>
				<div style="width: 100%;" class="d-flex" v-else-if="classa == 2">
					<div style="width: 70%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 520px;">
						<div style="margin: 10px;">销售线索记录</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<el-table :data="tableData" style="width: 100%" size="mini" key="table1">
							<el-table-column width="80">
								<template slot="header" slot-scope="scope">
									<div class="texts">编号</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.id }}</div>
								</template>
							</el-table-column>
							<el-table-column width="80">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交人</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.user }}</div>
								</template>
							</el-table-column>
							<el-table-column width="280">
								<template slot="header" slot-scope="scope">
									<div class="textsa">提交内容</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.text }}
								</template>
							</el-table-column>
							<el-table-column>
								<template slot="header" slot-scope="scope">
									<div class="texts">上传附件</div>
								</template>
								<template slot-scope="scope">
									<div class="textss"><el-button type="info" size="mini" plain>无</el-button></div>
								</template>
							</el-table-column>
							<el-table-column fixed="right" width="120">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交时间</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.time }}</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 26%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 240px;">
						<div style="margin: 10px;">销售线索记录</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<div class="m-2">
							<el-form :model="form" label-width="80px">
								<el-form-item label="* 线索内容"><el-input v-model="form.name" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="上传附件">
									<el-upload class="uploadfile" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											将文件拖到此处，或
											<em>点击上传</em>
										</div>
									</el-upload>
									<el-button type="primary" size="mini">确定提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
				<div style="width: 100%;" class="d-flex" v-else-if="classa == 3">
					<div style="width: 70%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 520px;">
						<div style="margin: 10px;">拜访记录</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<el-table :data="as" style="width: 100%" size="mini" key="table2">
							<el-table-column width="80">
								<template slot="header" slot-scope="scope">
									<div class="texts">编号</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.id }}</div>
								</template>
							</el-table-column>
							<el-table-column width="80">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交人</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.user }}</div>
								</template>
							</el-table-column>
							<el-table-column width="180">
								<template slot="header" slot-scope="scope">
									<div class="textsa">主要事宜</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.text }}
								</template>
							</el-table-column>
							<el-table-column width="200">
								<template slot="header" slot-scope="scope">
									<div class="textsa">拜访地点</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.city }}
								</template>
							</el-table-column>
							<el-table-column>
								<template slot="header" slot-scope="scope">
									<div class="texts">上传附件</div>
								</template>
								<template slot-scope="scope">
									<div class="textss"><el-button type="info" size="mini" plain>无</el-button></div>
								</template>
							</el-table-column>
							<el-table-column fixed="right" width="120">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交时间</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.time }}</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 26%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 320px;">
						<div style="margin: 10px;">添加拜访记录</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<div class="m-2">
							<el-form :model="form" label-width="80px">
								<el-form-item label="* 拜访内容"><el-input v-model="form.name" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="拜访地点"><el-input v-model="form.city" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="上传附件">
									<el-upload class="uploadfile" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											将文件拖到此处，或
											<em>点击上传</em>
										</div>
									</el-upload>
									<el-button type="primary" size="mini">确定提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
				<div style="width: 100%;" class="d-flex" v-else-if="classa == 4">
					<div style="width: 70%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 520px;">
						<div style="margin: 10px;">商机记录</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<el-table :data="bs" style="width: 100%" size="mini" key="table3">
							<el-table-column width="80">
								<template slot="header" slot-scope="scope">
									<div class="texts">编号</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.id }}</div>
								</template>
							</el-table-column>
							<el-table-column width="80">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交人</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.user }}</div>
								</template>
							</el-table-column>
							<el-table-column width="100">
								<template slot="header" slot-scope="scope">
									<div class="textsa">商机内容</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.sjnr }}
								</template>
							</el-table-column>
							<el-table-column width="100">
								<template slot="header" slot-scope="scope">
									<div class="textsa">商机阶段</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.sjjd }}
								</template>
							</el-table-column>
							<el-table-column width="100">
								<template slot="header" slot-scope="scope">
									<div class="textsa">商机类别</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.sjlb }}
								</template>
							</el-table-column>
							<el-table-column width="100">
								<template slot="header" slot-scope="scope">
									<div class="textsa">销售额</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.price }}
								</template>
							</el-table-column>
							<el-table-column>
								<template slot="header" slot-scope="scope">
									<div class="texts">上传附件</div>
								</template>
								<template slot-scope="scope">
									<div class="textss"><el-button type="info" size="mini" plain>无</el-button></div>
								</template>
							</el-table-column>
							<el-table-column fixed="right" width="120">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交时间</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.time }}</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 26%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 440px;">
						<div style="margin: 10px;">添加商机记录</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<div class="m-2">
							<el-form :model="form" label-width="80px">
								<el-form-item label="* 商机内容"><el-input v-model="form.name" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="销售额"><el-input-number v-model="num" @change="handleChange" size="mini"></el-input-number></el-form-item>
								<el-form-item label="商机阶段">
									<el-select v-model="value" size="mini" style="width: 100%;">
									    <el-option value="1">初步交流</el-option>
										<el-option value="2">需求沟通</el-option>
										<el-option value="3">商务沟通</el-option>
										<el-option value="4">签约交款</el-option>
										<el-option value="5">签约失败</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="商机类别">
									<el-select v-model="valuea" size="mini" style="width: 100%;">
									    <el-option value="1">快销</el-option>
										<el-option value="2">开放</el-option>
										<el-option value="3">合作</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="上传附件">
									<el-upload class="uploadfile" drag action="https://jsonplaceholder.typicode.com/posts/" multiple>
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											将文件拖到此处，或
											<em>点击上传</em>
										</div>
									</el-upload>
									<el-button type="primary" size="mini">确定提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
				<div style="width: 100%;" class="d-flex" v-else>
					<div style="width: 70%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 520px;">
						<div style="margin: 10px;">联系人列表</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<el-table :data="cs" style="width: 100%" size="mini" key="table4">
							<el-table-column width="60">
								<template slot="header" slot-scope="scope">
									<div class="texts">编号</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.id }}</div>
								</template>
							</el-table-column>
							<el-table-column width="60">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交人</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.user }}</div>
								</template>
							</el-table-column>
							<el-table-column width="60">
								<template slot="header" slot-scope="scope">
									<div class="texts">姓名</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.user }}</div>
								</template>
							</el-table-column>
							<el-table-column width="90">
								<template slot="header" slot-scope="scope">
									<div class="texts">手机号</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.phone }}</div>
								</template>
							</el-table-column>
							<el-table-column width="90">
								<template slot="header" slot-scope="scope">
									<div class="texts">固话</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.gh }}</div>
								</template>
							</el-table-column>
							<el-table-column width="90">
								<template slot="header" slot-scope="scope">
									<div class="texts">微信号</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.wxh }}</div>
								</template>
							</el-table-column>
							<el-table-column width="120">
								<template slot="header" slot-scope="scope">
									<div class="texts">邮箱</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.email }}</div>
								</template>
							</el-table-column>
							<el-table-column width="100">
								<template slot="header" slot-scope="scope">
									<div class="textsa">备注</div>
								</template>
								<template slot-scope="scope">
									{{ scope.row.desc }}
								</template>
							</el-table-column>
							<el-table-column fixed="right" width="120">
								<template slot="header" slot-scope="scope">
									<div class="texts">提交时间</div>
								</template>
								<template slot-scope="scope">
									<div class="textss">{{ scope.row.time }}</div>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 26%;margin: 1%;border: 1px solid rgb(0,0,0,0.1);height: 470px;">
						<div style="margin: 10px;">添加联系人</div>
						<div style="background: rgb(0,0,0,0.1);width: 100%;height: 1px;"></div>
						<div class="m-2">
							<el-form :model="form" label-width="80px">
								<el-form-item label="* 姓名"><el-input v-model="form.name" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="手机号"><el-input v-model="form.phone" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="固话"><el-input v-model="form.zjphone" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="微信号"><el-input v-model="form.phone" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="邮箱"><el-input v-model="form.emali" size="mini" style="width: 100%;"></el-input></el-form-item>
								<el-form-item label="备注">
									<el-input v-model="form.desc" size="mini" style="width: 100%;"></el-input>
									<el-button type="primary" size="mini">确定提交</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
				</div>
			</el-col>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'; // 引入 全局 公共数据
export default {
	inject: ['app', 'layout'],
	data() {
		return {
			value:'请选择',
			valuea:'请选择',
			classa: 1,
			num:48912,
			form: {
				name: '李白',
				lxr: '打工仔A',
				phone: 156451316,
				zjphone: '020-55464156',
				emali: '456489@qq.com',
				city: '广东省-惠州市-博罗县',
				xxcity: '广东省惠州市博罗县园洲镇马路边',
				desc: '有钱不赚没钱赚',
				state: 1,
				gzr: '打工仔C',
				zrr: '欧式牌',
				gxsw: '德玛西亚',
				sfr: '打工仔B',
				sftime: '2022-02-26 16:52:10',
				cjr: '哎呦喂',
				time: '2022-02-26 16:52:10'
			},
			tableData: [
				{
					time: '2016-05-02',
					user: '王小虎',
					text: '上海市普陀区金沙江路 1518 弄',
					id: 1
				},
				{
					time: '2016-05-04',
					user: '王小虎',
					text: '上海市普陀区金沙江路 1517 弄',
					id: 2
				},
				{
					time: '2016-05-01',
					user: '王小虎',
					text: '上海市普陀区金沙江路 1519 弄',
					id: 3
				},
				{
					time: '2016-05-03',
					user: '王小虎',
					text: '上海市普陀区金沙江路 1516 弄',
					id: 4
				}
			],
			as: [
				{
					time: '2016-05-02',
					user: '王小虎',
					text: '买楼',
					city:'上海市普陀区金沙江路 1518 弄',
					id: 1
				},
				{
					time: '2016-05-04',
					user: '王小虎',
					text: '打架',
					city:'上海市普陀区金沙江路 1518 弄',
					id: 2
				}
			],
			bs: [
				{
					time: '2016-05-02',
					user: '王小虎',
					sjnr:'买可乐',
					sjjd:'初步交流',
					sjlb:'快销',
					price:9456,
					id: 1
				},
				{
					time: '2016-05-02',
					user: '王小虎',
					sjnr:'买可乐',
					sjjd:'签约失败',
					sjlb:'快销',
					price:121156,
					id: 2
				}
			],
			cs: [
				{
					time: '2016-05-02',
					user: '王小虎',
					wxh:'sdkd1563',
					email:'456489@qq.com',
					desc:'快销',
					phone:945132136,
					gh:'020-485612',
					id: 1
				}
			]
		};
	},
	methods: {
		list(e) {
			this.classa = e;
		},
		handleChange(value) {
		        console.log(value);
		      }
	}
};
</script>

<style>
.texts {
	font-size: 13px;
	font-weight: 800;
	color: #000;
	text-align: center;
}
.textsa {
	font-size: 13px;
	font-weight: 800;
	color: #000;
}
.textss {
	text-align: center;
	font-size: 12px;
}
.uploadfile .el-upload-dragger {
	width: 100%;
	height: 60px;
	padding: 10px 15px;
}
.uploadfile .el-icon-upload {
	height: 40px;
	line-height: 40px;
	margin: 0 10px 0 0;
	display: block;
	overflow: hidden;
	text-align: center;
	font-size: 40px;
}
</style>
